export default "__VITE_ASSET__YHy9bbma__"